const storeUrl = 'https://hurleyburleyshop.myshopify.com'; // Replace with your store URL
const accessToken = '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'; // Replace with your access token
const apiVersion = '2023-10'; // Replace with the latest API version if needed

// List of variants to update
var variantsToUpdate = [];

// Function to update a single variant
const updateVariant = async (variantId, updateData) => {
  const url = `https://proxy-thatworks-app.herokuapp.com/${storeUrl}/admin/api/${apiVersion}/variants/${variantId}.json`;

  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': accessToken
      },
      body: JSON.stringify({
        variant: updateData
      })
    });

    if (!response.ok) {
      throw new Error(`Failed to update variant ${variantId}: ${response.statusText}`);
    }

    const data = await response.json();
  } catch (error) {
    console.error(`Error updating variant ${variantId}:`, error);
  }
};

// Function to update all variants in bulk
const goto_checkout = async () => {
  $('.cart_single_item').each(function () {
    const v_id = $(this).attr('v_id');
    const sku = $(this).attr('sku');

    // Only update variant if SKU is not blank
    if (sku && sku.trim() !== '') {
      variantsToUpdate.push({
        id: v_id,
        sku: sku
      });
    }
  })


  for (const variant of variantsToUpdate) {
    const {
      id,
      ...updateData
    } = variant; // Extract variant ID and update data
    await updateVariant(id, updateData);
  }

  window.location.href = '/checkout';
};
